import { FormDropdownComponent } from './form-dropdown/form-dropdown.component';
import { FormMoneyComponent } from './form-money/form-money.component';
import { FormPasswordComponent } from './form-password/form-password.component';
import { FormPhoneComponent } from './form-phone/form-phone.component';
import { FormTextAreaComponent } from './form-text-area/form-text-area.component';
import { FormTextComponent } from './form-text/form-text.component';
import { FormYesNoComponent } from './form-yes-no/form-yes-no.component';

export * from './base-control-value-accessor';
export * from './form-dropdown/form-dropdown.component';
export * from './form-money/form-money.component';
export * from './form-password/form-password.component';
export * from './form-phone/form-phone.component';
export * from './form-text-area/form-text-area.component';
export * from './form-text/form-text.component';
export * from './form-yes-no/form-yes-no.component';

export const UI_FORM_IMPORTS = [
  FormTextComponent,
  FormPasswordComponent,
  FormMoneyComponent,
  FormPhoneComponent,
  FormTextAreaComponent,
  FormDropdownComponent,
  FormYesNoComponent,
];
